import { useNavigate } from 'react-router-dom';
import { Banner } from '../../interfaces/Banner/Banner';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { ImageColumn } from '../../components/DataTable/ImageColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<Banner>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'title',
    name: 'Başlık',
    accessor: (row) => <TextColumn value={row.title} />,
  },
  {
    id: 'sort-order',
    name: 'Sıra',
    accessor: (row) => <TextColumn value={row.sortOrder.toString()} />,
  },
  {
    id: 'link-url',
    name: 'Link',
    accessor: (row) => <TextColumn value={row.linkUrl} />,
  },
  {
    id: 'image',
    name: 'Resim',
    accessor: (row) => <ImageColumn url={row.image} />,
    align: 'center',
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type BannersTableProps = {
  banners: Banner[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const BannersTable = (props: BannersTableProps) => {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.banners}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      onClick={(banner) => navigate(`/visual/banners/${banner.id}`)}
    />
  );
};
